













import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { Utilities as utils } from "@/shared/utilities";
import { AppConstants as _app } from "@/shared/app.constants";

@Component({
  components: {}
})
export default class BackButtonComponent extends Vue {

    get accessRights() {
        //@ts-ignore
        return this.$can(_app.actions.manage, _app.subjects.communication);
    }

    returnToDashboard() {
        this.$router.push({
            name: 'Communication'
        });
    }

}
